import {
  Divider,
  GKTextField,
  Grid2,
  PhoneInput,
  Typography,
} from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";

const GrievanceComplianceOfficerDetailsForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const [hasError, setHasError] = useState(false);

  return (
    <Grid2 container spacing={3} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(--neutral-900)">
          Grievance & Compliance Officer Details
        </Typography>
      </Grid2>

      <Grid2 container size={12} spacing={2}>
        <Grid2 size={12}>
          <Typography
            fontSize={10}
            fontWeight={600}
            color="var(--neutral-500)"
            textTransform={"uppercase"}
            letterSpacing={1}
          >
            Grievance Officer Details
          </Typography>
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.grievanceOfficerName"
            control={form.control}
            render={({ field }) => (
              <GKTextField {...field} inputLabel="Officer Name" />
            )}
          />
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.grievanceRedressalEmail"
            control={form.control}
            render={({ field }) => (
              <GKTextField {...field} inputLabel=" Redressal Email" />
            )}
          />
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.grievancePhoneNumber"
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "Please enter phone number",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <PhoneInput
                {...field}
                inputLabel="Phone Number"
                onSelectChange={(event: any) => {
                  form.setValue(
                    "compliance.grievanceComplainceOfficerDetails.grievanceCountryCode",
                    event,
                  );
                }}
                onTextChange={(event: any) => {
                  field.onChange(event);
                }}
                onTextValue={field.value}
                onSelectValue={form.getValues(
                  "compliance.grievanceComplainceOfficerDetails.grievanceCountryCode",
                )}
                error={!!error || hasError}
                helperText={error?.message}
                hasError={hasError}
                setHasError={setHasError}
              />
            )}
          />
        </Grid2>
      </Grid2>

      <Grid2 size={12}>
        <Divider />
      </Grid2>

      <Grid2 container size={12} spacing={2}>
        <Grid2 size={12}>
          <Typography
            fontSize={10}
            fontWeight={600}
            color="var(--neutral-500)"
            textTransform={"uppercase"}
            letterSpacing={1}
          >
            Compliance Officer Details
          </Typography>
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.complianceOfficerName"
            control={form.control}
            render={({ field }) => (
              <GKTextField {...field} inputLabel="Officer Name" />
            )}
          />
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.complianceRedressalEmail"
            control={form.control}
            render={({ field }) => (
              <GKTextField {...field} inputLabel=" Redressal Email" />
            )}
          />
        </Grid2>
        <Grid2 size={4}>
          <Controller
            name="compliance.grievanceComplainceOfficerDetails.compliancePhoneNumber"
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "Please enter phone number",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <PhoneInput
                {...field}
                inputLabel="Phone Number"
                onSelectChange={(event: any) => {
                  form.setValue(
                    "compliance.grievanceComplainceOfficerDetails.complianceCountryCode",
                    event,
                  );
                }}
                onTextChange={(event: any) => {
                  field.onChange(event);
                }}
                onTextValue={field.value}
                onSelectValue={form.getValues(
                  "compliance.grievanceComplainceOfficerDetails.complianceCountryCode",
                )}
                error={!!error || hasError}
                helperText={error?.message}
                hasError={hasError}
                setHasError={setHasError}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default GrievanceComplianceOfficerDetailsForm;
